import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Home } from 'lucide-react';

const NotFound = () => (
  <div style={styles.wrap} data-testid="notfound-page">
    <Helmet>
      <title>Strona nie znaleziona — CasaOthers</title>
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>
    <div style={styles.inner}>
      <p style={styles.code}>404</p>
      <h1 style={styles.h1}>Ta strona nie istnieje</h1>
      <p style={styles.p}>
        Strona, której szukasz, została przeniesiona lub nigdy nie istniała.
        Wróćmy do początku.
      </p>
      <div style={styles.actions}>
        <Link to="/" style={styles.btn} data-testid="notfound-home">
          <Home size={16} /> Strona główna
        </Link>
        <Link to="/woningen" style={styles.btnGhost} data-testid="notfound-properties">
          Zobacz nieruchomości
        </Link>
      </div>
    </div>
  </div>
);

const styles = {
  wrap: { minHeight: '70vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '4rem 1.5rem', background: '#FAF9F6' },
  inner: { maxWidth: '520px', textAlign: 'center' },
  code: { fontFamily: "'Playfair Display', serif", fontSize: '4rem', color: '#C5A059', margin: '0 0 0.5rem', lineHeight: 1 },
  h1: { fontFamily: "'Playfair Display', serif", fontSize: '2rem', color: '#1A1918', margin: '0 0 1rem' },
  p: { color: '#585755', fontSize: '1rem', lineHeight: 1.6, margin: '0 0 2rem' },
  actions: { display: 'flex', gap: '0.75rem', justifyContent: 'center', flexWrap: 'wrap' },
  btn: {
    display: 'inline-flex', alignItems: 'center', gap: '0.4rem', padding: '0.85rem 1.5rem',
    background: '#1A1918', color: '#C5A059', textDecoration: 'none', fontWeight: 700,
    fontSize: '0.82rem', letterSpacing: '0.06em', textTransform: 'uppercase',
  },
  btnGhost: {
    display: 'inline-flex', alignItems: 'center', padding: '0.85rem 1.5rem',
    border: '1px solid #C5A059', color: '#1A1918', textDecoration: 'none', fontWeight: 600,
    fontSize: '0.82rem', letterSpacing: '0.06em', textTransform: 'uppercase',
  },
};

export default NotFound;
